import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FiscoService {

  private url = environment.fiscoURL;

  constructor(private http: HttpClient) { }

  public getDataInscricao(inscricao: string, tipoImovel: string): Observable<Object> {
    return this.http.get(`${this.url}/get-imovel-data/${inscricao}/${tipoImovel}`);
  }

  public getDataCnae(codigo: string): Observable<Object> {
    return this.http.get(`${this.url}/get-atividade/${codigo}`);
  }

  public getDataInscricaoMunicipal(inscricao: string): Observable<Object> {
    return this.http.get(`${this.url}/get-data-inscricao-municipal/${inscricao}`);
  }

  public getDataDam(damId: string): Observable<Object> {
    return this.http.get(`${this.url}/get-data-dam/${damId}`);
  }

  public getDataNegociacao(negociacaoId: string): Observable<Object> {
    return this.http.get(`${this.url}/get-data-negociacao/${negociacaoId}`);
  }

  public getPdfNegociacaoFisco(negociacaoId: number): Observable<any> {
    return this.http.get(`${this.url}/get-data-pdf-negociacao/${negociacaoId}`);
  }

  public verificarPeriodoRefis(): Observable<any> {
    return this.http.get(`${this.url}/get-lei-refis/`);
  }

  public getDataAlvara(tipoAlvara: string, numero: number, exercicio: number): Observable<Object> {
    return this.http.get(`${this.url}/get-data-alvara/${tipoAlvara}/${numero}/${exercicio}`);
  }

  public getPdfExtratoDivida(cpf: string): Observable<any> {
      return this.http.get(`${this.url}/get-pdf-extrato-divida/${cpf}`);
  }

  public getPdfAlvaraSanitario(numeroAlvara: number, exercicio: number): Observable<any> {
    return this.http.get(`${this.url}/get-data-pdf-alvara-sanitario/${numeroAlvara}/${exercicio}`);
  }

  public getDataCertificado(numero: number, exercicio: number): Observable<Object> {
    return this.http.get(`${this.url}/get-data-certificado/${numero}/${exercicio}`);
  }

  public getPdfCertificado(numero: number, exercicio: number): Observable<any> {
    return this.http.get(`${this.url}/get-data-pdf-certificado/${numero}/${exercicio}`);
  }

}
